/** @prettier */
import { LOCATION_CHANGE } from 'react-router-redux';

import {
  CHANGE_PRODUCT,
  INITIALISE,
  setMBZeroConfig,
} from '@xanadu/ui-shared/modules/application/actions';
import * as api from '@xanadu/ui-shared/modules/application/api';
import { changeInlineBetslipID } from '@xanadu/ui-shared/modules/inlineBetslip/actions';
import { getStreamInfo } from '@xanadu/ui-shared/modules/streaming/actions';

import { PRODUCTS } from '../../constants';

import { all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';

function* requestMBZeroConfig() {
  const existingConfig = yield select((state) =>
    state.getIn(['application', 'mbZeroConfig', 'bettingOpeningTime'])
  );

  if (!existingConfig) {
    try {
      const { statusCode, contentlets } = yield call(api.getMBZeroConfig, { brand: 'matchbook' });

      if (statusCode === 200 && contentlets) {
        const {
          bettingOpeningTime,
          widgetVideoId,
          widgetHeader,
          widgetTitle,
          widgetDescription,
          widgetImage,
        } = contentlets[0] || {};

        if (bettingOpeningTime) {
          yield put(
            setMBZeroConfig({
              bettingOpeningTime,
              widgetVideoId,
              widgetHeader,
              widgetTitle,
              widgetDescription,
              widgetImage,
            })
          );
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('Error fetching MBZero config from dotCMS', e.message);
    }
  }
}

/**
  eventName: PropTypes.string,
 * Watches for the product change action and applies a class to the body element
 * @return {Generator} Non infinite
 */
function* watchProductChange() {
  while (true) {
    const existingProduct = yield select((state) => state.getIn(['application', 'product']));
    const { payload: product } = yield take(CHANGE_PRODUCT);

    if (existingProduct !== product && product === PRODUCTS.mbzero) {
      yield fork(requestMBZeroConfig);
    }
  }
}

/**
  eventName: PropTypes.string,
 * Watches for the product change action and applies a class to the body element
 * @return {Generator} Non infinite
 */
function* watchMBZeroVisit() {
  const { payload: product } = yield take(CHANGE_PRODUCT);
  let notMBZERO = product !== 'ZERO';
  while (notMBZERO) {
    const { payload: newProduct } = yield take(CHANGE_PRODUCT);
    notMBZERO = newProduct !== 'ZERO';
  }
  try {
    const userReturningTimes = localStorage.getItem('mbzero-user-returning-times');

    if (!userReturningTimes) {
      localStorage.setItem('mbzero-user-returning-times', '1');
      localStorage.setItem('mbzero-user-returning', 'true');
    } else {
      const update = `${parseInt(userReturningTimes, 10) + 1}`;
      localStorage.setItem('mbzero-user-returning-times', update);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Couldn't set user returning times flag", e);
  }

  // local store stuff
}

function* handleRouteChanges() {
  yield put(changeInlineBetslipID(null));
}

function* watchForAppInitialize() {
  yield take(INITIALISE);

  yield put(getStreamInfo());
}

export default function* root() {
  yield all([
    fork(watchProductChange),
    fork(watchMBZeroVisit),
    fork(watchForAppInitialize),
    takeEvery(LOCATION_CHANGE, handleRouteChanges),
  ]);
}
